import { render, staticRenderFns } from "./listSocios.vue?vue&type=template&id=2ddaf788&scoped=true&"
import script from "./listSocios.vue?vue&type=script&lang=js&"
export * from "./listSocios.vue?vue&type=script&lang=js&"
import style0 from "./listSocios.vue?vue&type=style&index=0&id=2ddaf788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddaf788",
  null
  
)

export default component.exports